import React, { useState, useEffect } from 'react';
import './inscripcion.css';
import { db } from '../../server/api';
import { doc, setDoc, getDoc } from 'firebase/firestore';
import ModalInformativo from '../../resources/modales/modalinformativo';
import tratamientoContenido from '../../resources/texto/tratamientodedatos.txt';
import logo from '../images/ensenartecorto.png';

const getTodayDocId = () => {
  const now = new Date();
  const dd = String(now.getDate()).padStart(2, '0');
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const yyyy = now.getFullYear();
  return `${dd}_${mm}_${yyyy}`;
};

const departamentosColombia = [
  { departamento: "Amazonas", capital: "Leticia" },
  { departamento: "Antioquia", capital: "Medellín" },
  { departamento: "Arauca", capital: "Arauca" },
  { departamento: "Atlántico", capital: "Barranquilla" },
  { departamento: "Bolívar", capital: "Cartagena de Indias" },
  { departamento: "Boyacá", capital: "Tunja" },
  { departamento: "Caldas", capital: "Manizales" },
  { departamento: "Caquetá", capital: "Florencia" },
  { departamento: "Casanare", capital: "Yopal" },
  { departamento: "Cauca", capital: "Popayán" },
  { departamento: "Cesar", capital: "Valledupar" },
  { departamento: "Chocó", capital: "Quibdó" },
  { departamento: "Córdoba", capital: "Montería" },
  { departamento: "Cundinamarca", capital: "Bogotá" },
  { departamento: "Guainía", capital: "Inírida" },
  { departamento: "Guaviare", capital: "San José del Guaviare" },
  { departamento: "Huila", capital: "Neiva" },
  { departamento: "La Guajira", capital: "Riohacha" },
  { departamento: "Magdalena", capital: "Santa Marta" },
  { departamento: "Meta", capital: "Villavicencio" },
  { departamento: "Nariño", capital: "Pasto" },
  { departamento: "Norte de Santander", capital: "San José de Cúcuta" },
  { departamento: "Putumayo", capital: "Mocoa" },
  { departamento: "Quindío", capital: "Armenia" },
  { departamento: "Risaralda", capital: "Pereira" },
  { departamento: "San Andrés y Providencia", capital: "San Andrés" },
  { departamento: "Santander", capital: "Bucaramanga" },
  { departamento: "Sucre", capital: "Sincelejo" },
  { departamento: "Tolima", capital: "Ibagué" },
  { departamento: "Valle del Cauca", capital: "Cali" },
  { departamento: "Vaupés", capital: "Mitú" },
  { departamento: "Vichada", capital: "Puerto Carreño" }
];

const capitalize = (str) => {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

const Inscripcion = () => {
  const [nombre, setNombre] = useState('');
  const [comoteEnteraste, setComoteEnteraste] = useState('');
  const [numeroDocumento, setNumeroDocumento] = useState('');
  const [numeroContacto, setNumeroContacto] = useState('');
  const [correo, setCorreo] = useState('');
  const [departamento, setDepartamento] = useState('');
  const [municipio, setMunicipio] = useState('');
  const [edad, setEdad] = useState('');
  const [programaInteres, setProgramaInteres] = useState('');
  const [aceptaDatos, setAceptaDatos] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  const [contenidoTratamiento, setContenidoTratamiento] = useState('');
  const [sugerenciasMunicipios, setSugerenciasMunicipios] = useState([]);
  const [mostrarSugerencias, setMostrarSugerencias] = useState(false);
  const [departamentosData, setDepartamentosData] = useState({});

  const programas = [
    'Convalidación Primaria',
    'Convalidación Bachillerato',
    'Home School Primera',
    'Home School Bachillerato',
    'Auxiliar de Servicios Farmacéuticos',
    'Auxiliar de Recreación y Deportes',
    'Asistencia y Soporte de Tecnologías',
    'Educación para la Primera Infancia',
    'Seguridad y Salud en el Trabajo',
    'Recursos Humanos',
    'Trabajo Agropecuario',
    'Contabilidad y Finanzas',
    'Asistente Legal y Jurídico',
    'Auxiliar de Clínico Veterinaria',
  ];

  useEffect(() => {
  fetch(tratamientoContenido)
    .then((res) => res.text())
    .then((text) => setContenidoTratamiento(text))
    .catch((err) => console.error('Error cargando tratamiento:', err));
}, []);

useEffect(() => {
  window.scrollTo(0, 0);
}, []);

  useEffect(() => {
    cargarDepartamentos();
  }, []);

  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => setError(''), 4000);
      return () => clearTimeout(timer);
    }
  }, [error]);

  const cargarDepartamentos = async () => {
    const defaultDepartamentos = {};
    departamentosColombia.forEach(dep => {
      defaultDepartamentos[dep.departamento] = {
        capital: dep.capital,
        municipios: [capitalize(dep.capital)]
      };
    });

    try {
      const docRef = doc(db, 'DEPARTAMENTOS', 'DEPARTAMENTOSDECOLOMBIA');
      const docSnap = await getDoc(docRef);
      
      if (docSnap.exists()) {
        setDepartamentosData(docSnap.data());
      } else {
        await setDoc(docRef, defaultDepartamentos);
        setDepartamentosData(defaultDepartamentos);
      }
    } catch (err) {
      console.error('Error cargando departamentos:', err);
      setError('No se pudo cargar la lista de departamentos. Verifica tu conexión.');
      setDepartamentosData(defaultDepartamentos);
    }
  };

  const handleMunicipioCambio = (value) => {
    const valorCapitalizado = capitalize(value);
    setMunicipio(valorCapitalizado);
    
    if (!departamento || !value) {
      setSugerenciasMunicipios([]);
      setMostrarSugerencias(false);
      return;
    }

    const deptoData = departamentosData[departamento];
    if (!deptoData || !deptoData.municipios) {
      setSugerenciasMunicipios([]);
      setMostrarSugerencias(false);
      return;
    }

    const filtradas = deptoData.municipios
      .filter(m => m.toUpperCase().includes(valorCapitalizado.toUpperCase()))
      .slice(0, 8);
    
    setSugerenciasMunicipios(filtradas);
    setMostrarSugerencias(filtradas.length > 0);
  };

  const seleccionarMunicipio = (munic) => {
    setMunicipio(munic);
    setSugerenciasMunicipios([]);
    setMostrarSugerencias(false);
  };

  const guardarMunicipioNuevo = async (munic) => {
    if (!departamento || !munic.trim()) return;

    try {
      const docRef = doc(db, 'DEPARTAMENTOS', 'DEPARTAMENTOSDECOLOMBIA');
      const deptoData = departamentosData[departamento];
      const municipCapitalizado = capitalize(munic);
      
      if (deptoData && !deptoData.municipios.includes(municipCapitalizado)) {
        const municipios = [...deptoData.municipios, municipCapitalizado].sort();
        await setDoc(
          docRef,
          { [departamento]: { ...deptoData, municipios } },
          { merge: true }
        );
        
        setDepartamentosData(prev => ({
          ...prev,
          [departamento]: { ...deptoData, municipios }
        }));
      }
    } catch (err) {
      console.error('Error guardando municipio nuevo:', err);
      setError('No se pudo guardar el nuevo municipio en la nube. Intenta nuevamente más tarde.');
    }
  };

  const onNombreChange = (event) => {
    const value = event.target.value.replace(/[0-9]/g, '');
    setNombre(value);
  };

  const onCorreoChange = (event) => {
    setCorreo(event.target.value.toLowerCase());
  };

  const onNumeroDocumentoChange = (event) => {
    const value = event.target.value.replace(/\D/g, '');
    setNumeroDocumento(value);
  };

  const onNumeroContactoChange = (event) => {
    const value = event.target.value.replace(/\D/g, '').slice(0, 10);
    setNumeroContacto(value);
  };

  const submitHandler = async (event) => {
    event.preventDefault();
    setError('');
    setSuccess('');

    const nombreTrim = nombre.trim().toUpperCase();

    if (!nombreTrim) {
      setError('El nombre completo es obligatorio.');
      return;
    }

    if (!comoteEnteraste) {
      setError('Debes seleccionar cómo te enteraste.');
      return;
    }

    if (!numeroDocumento) {
      setError('El número de documento es obligatorio.');
      return;
    }

    if (!numeroContacto || numeroContacto.length !== 10) {
      setError('El número de contacto debe tener exactamente 10 dígitos.');
      return;
    }

    if (!correo) {
      setError('El correo electrónico es obligatorio.');
      return;
    }

    if (!departamento) {
      setError('El departamento es obligatorio.');
      return;
    }

    if (!municipio) {
      setError('El municipio es obligatorio.');
      return;
    }

    if (!edad) {
      setError('La edad es obligatoria.');
      return;
    }

    if (!programaInteres) {
      setError('Debes seleccionar un programa de interés.');
      return;
    }

    if (!aceptaDatos) {
      setError('Debes aceptar la protección de datos para continuar.');
      return;
    }

    const docId = getTodayDocId();
    const storageKey = `INSCRIPCIONES_${docId}`;

    let current = {};
    try {
      current = JSON.parse(localStorage.getItem(storageKey) || '{}');
      if (typeof current !== 'object' || current === null) {
        current = {};
      }
    } catch (e) {
      current = {};
    }

    const userKey = `user_${Date.now()}`;
    const municipioCapitalizado = capitalize(municipio);
    const userData = {
      nombre: nombreTrim,
      comoteEnteraste,
      numeroDocumento,
      numeroContacto,
      correo: correo.trim(),
      departamento,
      municipio: municipioCapitalizado,
      edad,
      programaInteres,
      creado: new Date().toISOString(),
    };

    current[userKey] = userData;
    localStorage.setItem(storageKey, JSON.stringify(current));

    // Guardar municipio nuevo si es necesario
    await guardarMunicipioNuevo(municipioCapitalizado);

    const docRef = doc(db, 'INSCRIPCIONES', docId);
    setDoc(docRef, { [userKey]: userData }, { merge: true })
      .then(() => {
        console.log('Firestore INSCRIPCIONES guardado', docId, userKey, userData);
      })
      .catch((err) => {
        console.error('Error guardando en Firestore:', err);
        setError('No se pudo guardar en la nube. Verifica tu conexión o intenta más tarde.');
      });

    setSuccess('¡Inscripción completada! En breves te contactaremos.');
    setNombre('');
    setComoteEnteraste('');
    setNumeroDocumento('');
    setNumeroContacto('');
    setCorreo('');
    setDepartamento('');
    setMunicipio('');
    setEdad('');
    setProgramaInteres('');
    setAceptaDatos(false);

    setTimeout(() => {
      setSuccess('');
    }, 3000);
  };

  return (
    <>
      {error && <p className="inscripcion-error">{error}</p>}
      
      <section className="inscripcion-container">
        <div className="inscripcion-content">
          <div className="inscripcion-header">
            <img src={logo} alt="EnsenArte" className="inscripcion-logo" />
            <h1 className="inscripcion-title">Inscribete con Enseñarte</h1>
            <p className="inscripcion-subtitle">¿Estás listo para dar el primer paso hacia tu futuro?💙</p>
          </div>

          <form className="inscripcion-form" onSubmit={submitHandler} noValidate>
            <div className="inscripcion-grid">
              <label className="inscripcion-label">
                Nombre y apellidos completos *
                <input
                  className="inscripcion-input"
                  type="text"
                  value={nombre}
                  onChange={onNombreChange}
                  placeholder="Juan Pérez García"
                  required
                />
              </label>

              <div className="inscripcion-label">
                ¿Cómo te enteraste? *
                <div className="container">
                  <label>
                    <input
                      type="radio"
                      name="comoteEnteraste"
                      value="Redes sociales"
                      checked={comoteEnteraste === 'Redes sociales'}
                      onChange={(e) => setComoteEnteraste(e.target.value)}
                    />
                    <span>Redes sociales</span>
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="comoteEnteraste"
                      value="Secretaría de la Mujer y Equidad de Género"
                      checked={comoteEnteraste === 'Secretaría de la Mujer y Equidad de Género'}
                      onChange={(e) => setComoteEnteraste(e.target.value)}
                    />
                    <span>Secretaría de la Mujer y Equidad de Género</span>
                  </label>
                </div>
              </div>

              <label className="inscripcion-label">
                Número de documento *
                <input
                  className="inscripcion-input"
                  type="text"
                  value={numeroDocumento}
                  onChange={onNumeroDocumentoChange}
                  placeholder="1234567890"
                  inputMode="numeric"
                  required
                />
              </label>

              <label className="inscripcion-label">
                Número de contacto *
                <input
                  className="inscripcion-input"
                  type="text"
                  value={numeroContacto.length > 0 ? (numeroContacto.length <= 3 ? numeroContacto : numeroContacto.length <= 6 ? numeroContacto.slice(0, 3) + ' ' + numeroContacto.slice(3) : numeroContacto.length <= 8 ? numeroContacto.slice(0, 3) + ' ' + numeroContacto.slice(3, 6) + ' ' + numeroContacto.slice(6) : numeroContacto.slice(0, 3) + ' ' + numeroContacto.slice(3, 6) + ' ' + numeroContacto.slice(6, 8) + ' ' + numeroContacto.slice(8, 10)) : ''}
                  onChange={onNumeroContactoChange}
                  placeholder="300 123 45 67"
                  inputMode="numeric"
                  maxLength={14}
                  required
                />
              </label>

              <label className="inscripcion-label">
                Correo electrónico *
                <input
                  className="inscripcion-input"
                  type="email"
                  value={correo}
                  onChange={onCorreoChange}
                  placeholder="correo@dominio.com"
                  required
                />
              </label>

              <label className="inscripcion-label">
                Departamento *
                <select
                  className="inscripcion-select"
                  value={departamento}
                  onChange={(e) => {
                    setDepartamento(e.target.value);
                    setMunicipio('');
                    setSugerenciasMunicipios([]);
                  }}
                  required
                >
                  <option value="">Selecciona un departamento</option>
                  {Object.keys(departamentosData).map((depto) => (
                    <option key={depto} value={depto}>
                      {depto}
                    </option>
                  ))}
                </select>
              </label>

              <label className="inscripcion-label">
                Municipio *
                <div className="autocomplete-container">
                  <input
                    className="inscripcion-input"
                    type="text"
                    value={municipio}
                    onChange={(e) => handleMunicipioCambio(e.target.value)}
                    onFocus={() => municipio && setMostrarSugerencias(true)}
                    placeholder="Escribe tu municipio"
                    required
                    disabled={!departamento}
                  />
                  {mostrarSugerencias && sugerenciasMunicipios.length > 0 && (
                    <ul className="autocomplete-list">
                      {sugerenciasMunicipios.map((munic, idx) => (
                        <li
                          key={idx}
                          onClick={() => seleccionarMunicipio(munic)}
                          className="autocomplete-item"
                        >
                          {munic}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </label>

              <label className="inscripcion-label">
                Edad *
                <input
                  className="inscripcion-input"
                  type="text"
                  value={edad}
                  onChange={(e) => setEdad(e.target.value.replace(/\D/g, '').slice(0, 3))}
                  placeholder="25"
                  inputMode="numeric"
                  maxLength="3"
                  required
                />
              </label>

              <label className="inscripcion-label">
                Programa de interés *
                <select
                  className="inscripcion-select"
                  value={programaInteres}
                  onChange={(e) => setProgramaInteres(e.target.value)}
                  required
                >
                  <option value="" disabled>Selecciona un programa</option>
                  {programas.map((programa) => (
                    <option key={programa} value={programa}>
                      {programa}
                    </option>
                  ))}
                </select>
              </label>
            </div>

            {success && <p className="inscripcion-success">{success}</p>}

            <div className="checkbox-wrapper-30" style={{ marginTop: '1.5rem', marginBottom: '1.5rem' }}>
              <span className="checkbox">
                <input 
                  type="checkbox" 
                  checked={aceptaDatos}
                  onChange={() => setModalOpen(true)}
                />
                <svg>
                  <use xlinkHref="#checkbox-30" className="checkbox"></use>
                </svg>
              </span>
              <label 
                className="formulario-checkbox-text"
                onClick={() => setModalOpen(true)}
              >
                Acepto la LEY DE PROTECCIÓN DE DATOS 1581 DE 2012 *
              </label>
              <svg xmlns="http://www.w3.org/2000/svg" style={{ display: 'none' }}>
                <symbol id="checkbox-30" viewBox="0 0 22 22">
                  <path fill="none" stroke="currentColor" d="M5.5,11.3L9,14.8L20.2,3.3l0,0c-0.5-1-1.5-1.8-2.7-1.8h-13c-1.7,0-3,1.3-3,3v13c0,1.7,1.3,3,3,3h13 c1.7,0,3-1.3,3-3v-13c0-0.4-0.1-0.8-0.3-1.2"/>
                </symbol>
              </svg>
            </div>

            <button type="submit" className="inscripcion-submit-btn">Enviar inscripción</button>
          </form>
        </div>
      </section>

      {/* Modal Informativo de Protección de Datos */}
      <ModalInformativo 
        isOpen={modalOpen} 
        onClose={() => setModalOpen(false)}
        onAccept={() => setAceptaDatos(true)}
        titulo="Ley de Protección de Datos 1581 de 2012"
        contenido={contenidoTratamiento}
      />
    </>
  );
};

export default Inscripcion;
